export const NOT_STARTED_REQUIRED = "NOT_STARTED_REQUIRED";
export const NOT_STARTED_OPTIONAL = "NOT_STARTED_OPTIONAL";
export const COMPLETED = "COMPLETED";

export const NOT_STARTED_STATUSES = [
  NOT_STARTED_REQUIRED,
  NOT_STARTED_OPTIONAL,
];
